import React from "react";
import Button from "../../Buttons/Button";

interface IPrintWineProps {
  onClick: () => void;
  label: string;
  type?: "tertiary" | "secondary" | "primary";
  className?: string;
}

const PrintButton = ({ onClick, label, type, className }: IPrintWineProps) => {
  return (
    <Button
      type={type || "tertiary"}
      icon={
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5 mr-2 -mt-2"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M5 4v3H4a2 2 0 00-2 2v3a2 2 0 002 2h1v2a2 2 0 002 2h6a2 2 0 002-2v-2h1a2 2 0 002-2V9a2 2 0 00-2-2h-1V4a2 2 0 00-2-2H7a2 2 0 00-2 2zm8 0H7v3h6V4zm0 8H7v4h6v-4z"
            clipRule="evenodd"
          />
        </svg>
      }
      label={label}
      onClick={onClick}
      className={className}
    />
  );
};

export default PrintButton;
